"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var react_2 = require("react");

var components_utils_1 = require("@conte-ltd/components-utils");

var button_1 = require("@react-aria/button");

var interactions_1 = require("@react-aria/interactions");

function _Button(props, fwRef) {
  var ref = (0, react_2.useRef)(null);
  var children = props.children,
      as = props.as,
      leftElement = props.leftElement,
      rightElement = props.rightElement,
      isDisabled = props.isDisabled,
      isPreventDefault = props.isPreventDefault,
      isStopPropagation = props.isStopPropagation,
      variant = props.variant,
      colorScheme = props.colorScheme;

  var _a = (0, button_1.useButton)(__assign(__assign({}, props), {
    elementType: as
  }), ref),
      buttonProps = _a.buttonProps,
      isPressed = _a.isPressed;

  var _b = (0, interactions_1.useHover)(props),
      hoverProps = _b.hoverProps,
      isHovered = _b.isHovered;

  var Component = as !== null && as !== void 0 ? as : 'button';
  return (0, jsx_runtime_1.jsxs)(Component, __assign({
    css: [(0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          cursor: pointer;\n          position: relative;\n          display: inline-flex;\n          justify-content: center;\n          align-items: center;\n          transition: all 0.2s;\n          text-align: center;\n\n          &:focus {\n            outline: none;\n          }\n\n          &[data-disabled] {\n            pointer-events: none;\n          }\n\n          & > [data-left-icon] {\n            position: absolute;\n            left: 0;\n            top: 50%;\n            transform: translateY(-50%);\n          }\n\n          & > [data-right-icon] {\n            position: absolute;\n            right: 0;\n            top: 50%;\n            transform: translateY(-50%);\n          }\n        "], ["\n          cursor: pointer;\n          position: relative;\n          display: inline-flex;\n          justify-content: center;\n          align-items: center;\n          transition: all 0.2s;\n          text-align: center;\n\n          &:focus {\n            outline: none;\n          }\n\n          &[data-disabled] {\n            pointer-events: none;\n          }\n\n          & > [data-left-icon] {\n            position: absolute;\n            left: 0;\n            top: 50%;\n            transform: translateY(-50%);\n          }\n\n          & > [data-right-icon] {\n            position: absolute;\n            right: 0;\n            top: 50%;\n            transform: translateY(-50%);\n          }\n        "]))), variant === 'solid' && (0, react_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            color: white;\n            background: ", ";\n          "], ["\n            color: white;\n            background: ", ";\n          "])), colorScheme), variant === 'outline' && (0, react_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            color: ", ";\n            border: solid 1px;\n          "], ["\n            color: ", ";\n            border: solid 1px;\n          "])), colorScheme), variant === 'text' && (0, react_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            color: ", ";\n          "], ["\n            color: ", ";\n          "])), colorScheme)],
    "data-hovered": isHovered || undefined,
    "data-pressed": isPressed || undefined,
    "data-disabled": isDisabled || undefined,
    ref: (0, components_utils_1.mergeRefs)([ref, fwRef])
  }, (0, components_utils_1.mergeProps)({
    onClick: function onClick(e) {
      if (isPreventDefault) {
        e.preventDefault();
      }

      if (isStopPropagation) {
        e.stopPropagation();
      }
    }
  }, buttonProps, hoverProps, (0, components_utils_1.styleProps)(props)), {
    children: [(0, components_utils_1.useRunIfFunction)(leftElement, {
      'data-left-icon': true
    }), children, (0, components_utils_1.useRunIfFunction)(rightElement, {
      'data-right-icon': true
    })]
  }), void 0);
}

exports.Button = (0, react_2.forwardRef)(_Button);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;